export default __webpack_public_path__ + "static/media/flexline_hd_logo_en.473a756a.png";